<template>
  <div id="app">
<fingerprint-spinner
  :animation-duration="1500"
  :size="64"
  color="#BB86FC"
/>
  </div>
</template>

<script>  
  import {FingerprintSpinner} from 'epic-spinners'
  export default {
    components: {
      FingerprintSpinner
    }
  }
</script>